import React from 'react';
import Modal from 'react-modal';
import CloseIcon from '@mui/icons-material/Close';
import InfoOutlinedIcon from '@mui/icons-material/InfoOutlined';
import { Button } from '../../Buttons/Button';
import { IPlanViewModel } from 'viewModels';
import { getCycleLabel } from '../../../utils/planCycleLabel';
import { Container, Header, Content } from './styles';

type Props = {
  isOpen: boolean;
  plan?: IPlanViewModel;
  onConfirm: () => void;
  loading: boolean;
  onRequestClose: () => void;
  pendingPaymentError?: string | null;
};

export function ModalConfirmPlan({ isOpen, plan, onConfirm, onRequestClose, loading, pendingPaymentError }: Props) {
  return (
    <Modal
      isOpen={isOpen}
      onRequestClose={onRequestClose}
      overlayClassName="react-modal-overlay"
      className="react-add-modal-content">
      <Container>
        <Header>
          <div className="subHeader">
            <h1>Confirmar contratação</h1>
          </div>
          <div className="close-div">
            <button type="button" onClick={onRequestClose} disabled={loading}>
              <CloseIcon fontSize="small" />
            </button>
          </div>
        </Header>
        <Content>
          {pendingPaymentError ? (
            <div className="summary">
              <div className="icon">
                ⏳
              </div>
              <div className="text">
                <h2>Pagamento pendente</h2>
                <p>{pendingPaymentError}</p>
              </div>
            </div>
          ) : (
            <div className="summary">
              <div className="icon">
                <InfoOutlinedIcon />
              </div>
              <div className="text">
                {plan ? (
                  <>
                    <h2>{plan.name}</h2>
                    <p>
                      Você está prestes a contratar o plano <strong>{plan.name}</strong> por{' '}
                      <strong>R$ {plan.price.toFixed(2)}</strong> / {getCycleLabel(plan.billingCycle)}.
                    </p>
                  </>
                ) : (
                  <p>Deseja prosseguir para o checkout?</p>
                )}
              </div>
            </div>
          )}

          <div className="actions">
            <Button
              text={pendingPaymentError ? "Fechar" : "Cancelar"}
              dimensions={{ width: '10rem', height: '2.25rem' }}
              color="tertiary_500"
              backgroundHoverColor="tertiary_500"
              textHoverColor="background_white"
              border={{ color: 'tertiary_500', width: 1 }}
              onClick={loading ? () => { } : onRequestClose}
              disabled={loading}
              loading={loading}
            />
            {!pendingPaymentError && (
              <Button
                text='Assinar'
                dimensions={{ width: '12rem', height: '2.25rem' }}
                background="secondary"
                backgroundHoverColor="primary"
                onClick={loading ? () => { } : onConfirm}
                disabled={loading}
                loading={loading}
              />
            )}
          </div>
        </Content>
      </Container>
    </Modal>
  );
}


